import { render } from "./NoData.vue?vue&type=template&id=be718c98&scoped=true"
const script = {}

import "./NoData.vue?vue&type=style&index=0&id=be718c98&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be718c98"]])

export default __exports__